import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32ef2a26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" The origin must be included in the nyquist plot")
const _hoisted_3 = { class: "container" }

import { ref, Ref } from "vue";
import CircuitSelector from '@/components/CircuitSelector/CircuitSelector.vue';
import { PlotData } from '@/components/Impedance';
import NyquistPlot from '@/components/NyquistPlot.vue';
import ParameterSlider from '@/components/ParameterSlider.vue';
import BodePlot from "@/components/BodePlot.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImpedanceGenerator',
  setup(__props) {

const data:Ref<PlotData[]> = ref([]);
const onDataReceived = (e:PlotData[])=>{
    data.value = e;
}

const check1 = ref(true);
const refresh = ()=>{
    data.value = JSON.parse(JSON.stringify(data.value));//計算リソースが勿体ない
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CircuitSelector),
    _createElementVNode("label", null, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((check1).value = $event)),
        onChange: refresh
      }, null, 544), [
        [_vModelCheckbox, check1.value]
      ]),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ParameterSlider, { onEmit: onDataReceived }),
      _createVNode(NyquistPlot, {
        data: data.value,
        config: {zeroline: check1.value}
      }, null, 8, ["data", "config"])
    ]),
    _createVNode(BodePlot, { data: data.value }, null, 8, ["data"])
  ]))
}
}

})